
function toggleAcc(btn) {
  var acc  = btn.parentElement;
  var body = btn.nextElementSibling;
  var open = acc.classList.contains('open');
  document.querySelectorAll('.acc-item').forEach(function (a) {
    a.classList.remove('open');
    if (a.querySelector('.acc-body')) a.querySelector('.acc-body').style.maxHeight = '0px';
    var ic = a.querySelector('.ic');
    if (ic) ic.textContent = '+';
  });
  if (!open) {
    acc.classList.add('open');
    body.style.maxHeight = body.scrollHeight + 'px';
    var openIc = btn.querySelector('.ic');
    if (openIc) openIc.textContent = '\u2212';
  }
}

function accToggle(btn) {
  var body = btn ? btn.nextElementSibling : null;
  if (!btn || !body) return;
  var ic = btn.querySelector('.ic');
  var isOpen = btn.getAttribute('aria-expanded') === 'true';

  document.querySelectorAll('.acc-btn').forEach(function (otherBtn) {
    var otherBody = otherBtn.nextElementSibling;
    if (otherBody) otherBody.style.maxHeight = '0px';
    otherBtn.setAttribute('aria-expanded', 'false');
    var otherIcon = otherBtn.querySelector('.ic');
    if (otherIcon) otherIcon.textContent = '+';
  });

  if (!isOpen) {
    body.style.maxHeight = body.scrollHeight + 'px';
    btn.setAttribute('aria-expanded', 'true');
    if (ic) ic.textContent = '\u2212';
  }
}

var _pdpGalleryIndex = 0;
var _pdpGallerySwapTimer = null;

function getPdpThumbs() {
  return Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb'));
}

function normalizeImageUrl(url) {
  return String(url || '')
    .replace(/^https?:/, '')
    .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*)\.(?=[a-zA-Z]{2,5}(?:\?|$))/, '.')
    .split('?')[0];
}

function updatePdpGalleryUi(index) {
  var thumbs = getPdpThumbs();
  if (!thumbs.length) return;
  _pdpGalleryIndex = Math.max(0, Math.min(index, thumbs.length - 1));

  thumbs.forEach(function (thumb, thumbIndex) {
    var active = thumbIndex === _pdpGalleryIndex;
    thumb.classList.toggle('is-active', active);
    thumb.setAttribute('aria-current', active ? 'true' : 'false');
  });

  var activeThumb = thumbs[_pdpGalleryIndex];
  var thumbRail = document.getElementById('pdp-thumbs');
  if (activeThumb && thumbRail && thumbRail.scrollWidth > thumbRail.clientWidth) {
    var targetLeft = activeThumb.offsetLeft - ((thumbRail.clientWidth - activeThumb.offsetWidth) / 2);
    if (thumbRail.scrollTo) thumbRail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    else thumbRail.scrollLeft = Math.max(0, targetLeft);
  }

  var counter = document.getElementById('pdp-gallery-count');
  if (counter) counter.textContent = (_pdpGalleryIndex + 1) + ' / ' + thumbs.length;

  var prev = document.querySelector('.pdp-gallery-arrow--prev');
  var next = document.querySelector('.pdp-gallery-arrow--next');
  var disableArrows = thumbs.length < 2;
  if (prev) prev.disabled = disableArrows;
  if (next) next.disabled = disableArrows;
}

function setPdpGalleryImage(index, options) {
  var thumbs = getPdpThumbs();
  var main = document.getElementById('pdp-main');
  if (!thumbs.length || !main) return;
  var safeIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
  var thumb = thumbs[safeIndex];
  var thumbImage = thumb.querySelector('img');
  var newSrc = thumb.getAttribute('data-full') || (thumbImage ? thumbImage.src : '');
  var newAlt = thumbImage ? thumbImage.alt : main.alt;
  if (!newSrc) return;

  var swap = function () {
    main.src = newSrc;
    main.setAttribute('data-full', newSrc);
    if (newAlt) main.alt = newAlt;
    main.style.opacity = '1';

    var result = document.getElementById('pdp-zoom-result');
    if (result) result.style.backgroundImage = 'url("' + newSrc.replace(/"/g, '\\"') + '")';
  };

  if (_pdpGallerySwapTimer) window.clearTimeout(_pdpGallerySwapTimer);
  if (!options || !options.immediate) {
    main.style.opacity = '0';
    _pdpGallerySwapTimer = window.setTimeout(function () {
      swap();
      _pdpGallerySwapTimer = null;
    }, 120);
  } else {
    swap();
  }
  updatePdpGalleryUi(safeIndex);
}

function pdpThumb(thumb) {
  var thumbs = getPdpThumbs();
  var index = thumbs.indexOf(thumb);
  if (index < 0) return;
  setPdpGalleryImage(index);
}

function pdpGalleryStep(direction) {
  var thumbs = getPdpThumbs();
  if (thumbs.length < 2) return;
  setPdpGalleryImage(_pdpGalleryIndex + direction);
}

function pdpZoomOpen() {
  var main = document.getElementById('pdp-main');
  var overlay = document.getElementById('pdp-zoom-overlay');
  var zoomImage = document.getElementById('pdp-zoom-img');
  if (!main || !overlay || !zoomImage) return;
  zoomImage.src = main.getAttribute('data-full') || main.src;
  zoomImage.alt = main.alt || 'Product image';
  overlay.classList.add('is-open');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  if (typeof updateStickyAtcVisibility === 'function') updateStickyAtcVisibility();
  var closeButton = document.getElementById('pdp-zoom-close');
  if (closeButton) closeButton.focus({ preventScroll: true });
}

function initPdpGallery() {
  var thumbs = getPdpThumbs();
  var wrap = document.getElementById('pdp-main-wrap');
  if (!thumbs.length || !wrap) return;

  var activeIndex = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
  if (activeIndex < 0) activeIndex = 0;
  updatePdpGalleryUi(activeIndex);

  wrap.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      pdpGalleryStep(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      pdpGalleryStep(1);
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      pdpZoomOpen();
    }
  });

  var touchStartX = 0;
  var touchStartY = 0;
  wrap.addEventListener('touchstart', function (event) {
    if (!event.touches || event.touches.length !== 1) return;
    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
  }, { passive: true });
  wrap.addEventListener('touchend', function (event) {
    if (!event.changedTouches || event.changedTouches.length !== 1) return;
    var deltaX = event.changedTouches[0].clientX - touchStartX;
    var deltaY = event.changedTouches[0].clientY - touchStartY;
    if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    pdpGalleryStep(deltaX < 0 ? 1 : -1);
  }, { passive: true });
}

var _pdpQty = 1;
function getProductVariants() {
  var node = document.getElementById('ProductVariantsJSON');
  if (!node) return [];
  try {
    return JSON.parse(node.textContent || '[]') || [];
  } catch (e) {
    return [];
  }
}

function getVariantById(id) {
  return getProductVariants().find(function (variant) {
    return String(variant.id) === String(id);
  }) || null;
}

function getDisplayOptionValue(value) {
  var text = value == null ? '' : String(value);
  return text.trim().toLowerCase() === 'chocolate brown' ? 'Black' : text;
}

function getVariantTitle(variant) {
  if (!variant) return '';
  var title = '';
  if (variant.public_title && variant.public_title !== 'Default Title') title = variant.public_title;
  else if (variant.title && variant.title !== 'Default Title') title = variant.title;
  else if (Array.isArray(variant.options)) title = variant.options.filter(Boolean).join(' · ');
  return title.replace(/Chocolate Brown/gi, 'Black');
}

function getStockMessage(variant) {
  if (!variant) return { text: 'Unavailable', state: 'soldout' };
  if (!variant.available) return { text: 'Sold out', state: 'soldout' };
  var qty = Number(variant.inventory_quantity || 0);
  if (qty > 0 && qty <= 3) {
    return { text: 'Only ' + qty + ' left in stock', state: 'low' };
  }
  if (qty > 0) return { text: 'In stock', state: 'instock' };
  return { text: 'Available now', state: 'instock' };
}

function moneyFromCents(cents) {
  var amount = (Number(cents || 0) / 100);
  try {
    var currency = document.documentElement.getAttribute('data-currency') || 'USD';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(amount);
  } catch (e) {
    return '$' + amount.toFixed(2);
  }
}

function getOptionGroups() {
  return Array.prototype.slice.call(document.querySelectorAll('.pdp-option-group'));
}

function getActiveValues() {
  return getOptionGroups().map(function (group) {
    var active = group.querySelector('.pdp-choice.is-active');
    if (active) return active.dataset.optionValue;
    var firstEnabled = group.querySelector('.pdp-choice:not(.is-disabled)');
    return firstEnabled ? firstEnabled.dataset.optionValue : '';
  });
}

function findExactVariant(variants, values) {
  return variants.find(function (variant) {
    return values.every(function (value, idx) {
      return String(variant.options[idx]) === String(value);
    });
  }) || null;
}

function findPartialVariant(variants, values) {
  return variants.find(function (variant) {
    return values.every(function (value, idx) {
      return !value || String(variant.options[idx]) === String(value);
    });
  }) || null;
}

function setActiveButton(group, value) {
  var buttons = group.querySelectorAll('.pdp-choice');
  buttons.forEach(function (btn) {
    var match = String(btn.dataset.optionValue) === String(value);
    btn.classList.toggle('is-active', match);
    btn.setAttribute('aria-pressed', match ? 'true' : 'false');
  });
  var label = group.querySelector('.pdp-selected-label');
  if (label) label.textContent = getDisplayOptionValue(value);
}

function updateVariantImage(variant) {
  if (!variant) return;
  var main = document.getElementById('pdp-main');
  if (!main) return;

  var src = '';
  var mediaId = '';
  if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
    src = variant.featured_media.preview_image.src;
    mediaId = variant.featured_media.id || '';
  } else if (variant.featured_image && variant.featured_image.src) {
    src = variant.featured_image.src;
  } else if (variant.image && variant.image.src) {
    src = variant.image.src;
  }
  if (!src) return;

  var thumbs = getPdpThumbs();
  var matchingThumb = null;
  if (mediaId) {
    matchingThumb = document.querySelector('.pdp-thumb[data-media-id="' + String(mediaId).replace(/"/g, '\\"') + '"]');
  }
  if (!matchingThumb) {
    var normalizedSrc = normalizeImageUrl(src);
    matchingThumb = thumbs.find(function (thumb) {
      return normalizeImageUrl(thumb.getAttribute('data-full')) === normalizedSrc;
    }) || null;
  }

  if (matchingThumb) {
    var index = thumbs.indexOf(matchingThumb);
    setPdpGalleryImage(index);
  } else if (normalizeImageUrl(main.src) !== normalizeImageUrl(src)) {
    main.style.opacity = '0';
    window.setTimeout(function () {
      main.src = src;
      main.setAttribute('data-full', src);
      main.style.opacity = '1';
    }, 120);
  }

  var stickyImage = document.querySelector('.satc-left img');
  if (stickyImage) stickyImage.src = src;
}

function updatePriceNodes(variant) {
  if (!variant) return;
  var price = moneyFromCents(variant.price);
  document.querySelectorAll('[data-pdp-price]').forEach(function (node) {
    node.textContent = price;
  });

  var compareAt = Number(variant.compare_at_price || 0);
  var hasComparePrice = compareAt > Number(variant.price || 0);
  document.querySelectorAll('[data-pdp-compare-price]').forEach(function (node) {
    node.hidden = !hasComparePrice;
    if (hasComparePrice) node.textContent = moneyFromCents(compareAt);
  });
}

function updateVariantMeta(variant) {
  var label = getVariantTitle(variant) || 'Selected variant';
  document.querySelectorAll('[data-pdp-variant-label]').forEach(function (node) {
    node.textContent = label;
  });
}

function updateStockNodes(variant) {
  var node = document.getElementById('pdp-stock');
  var label = document.getElementById('pdp-stock-label');
  var info = getStockMessage(variant);
  if (label) label.textContent = info.text;
  if (!node) return;
  node.classList.remove('is-soldout', 'is-low', 'is-instock');
  node.classList.add('is-' + info.state);
}

function updateActionButtons(variant) {
  var atcBtn = document.getElementById('pdp-atc');
  var buyBtn = document.getElementById('pdp-buy');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var atcLabel = atcBtn ? (atcBtn.dataset.defaultLabel || 'Add to Cart') : 'Add to Cart';
  var buyLabel = buyBtn ? (buyBtn.dataset.defaultLabel || 'Buy it now') : 'Buy it now';
  var stickyLabel = stickyBtn ? (stickyBtn.dataset.defaultLabel || 'Add to Cart') : 'Add to Cart';
  var available = !!variant && variant.available;

  [atcBtn, buyBtn, stickyBtn].forEach(function (btn) {
    if (!btn) return;
    btn.disabled = !available;
    btn.setAttribute('aria-disabled', available ? 'false' : 'true');
  });

  if (atcBtn) {
    atcBtn.innerHTML = available
      ? '<span class="btn-label">' + atcLabel + '</span> &mdash; <span id="pdp-atc-price" data-pdp-price>' + moneyFromCents(variant.price) + '</span>'
      : '<span class="btn-label">Sold out</span>';
  }
  if (buyBtn) buyBtn.textContent = available ? buyLabel : 'Sold out';
  if (stickyBtn) stickyBtn.textContent = available ? stickyLabel : 'Sold out';
}

function refreshAvailability(variants, selections) {
  getOptionGroups().forEach(function (group, optionIndex) {
    group.querySelectorAll('.pdp-choice').forEach(function (btn) {
      var testValues = selections.slice();
      testValues[optionIndex] = btn.dataset.optionValue;
      var ok = variants.some(function (variant) {
        return !!variant.available && testValues.every(function (value, idx) {
          return !value || String(variant.options[idx]) === String(value);
        });
      });
      btn.disabled = !ok;
      btn.classList.toggle('is-disabled', !ok);
    });
  });
}

function applyVariantSelection(variant, variants) {
  if (!variant) return;
  var hidden = document.getElementById('pdp-variant');
  if (hidden) hidden.value = variant.id;

  getOptionGroups().forEach(function (group, idx) {
    if (variant.options && variant.options[idx] !== undefined) {
      setActiveButton(group, variant.options[idx]);
    }
  });

  updatePriceNodes(variant);
  updateVariantMeta(variant);
  updateStockNodes(variant);
  updateVariantImage(variant);
  updateActionButtons(variant);
  refreshAvailability(variants, variant.options ? variant.options.slice() : []);

  if (window.history && window.history.replaceState && variant.id) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }
}

function initPdpVariantUI() {
  var variants = getProductVariants();
  var groups = getOptionGroups();
  var hidden = document.getElementById('pdp-variant');
  if (!variants.length || !groups.length || !hidden) return;

  groups.forEach(function (group) {
    group.querySelectorAll('.pdp-choice').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        setActiveButton(group, btn.dataset.optionValue);
        var selections = getActiveValues();
        var exact = findExactVariant(variants, selections);
        var partial = findPartialVariant(variants, selections);
        var chosen = exact || partial || variants[0];
        applyVariantSelection(chosen, variants);
      });
    });
  });

  var initialValues = getActiveValues();
  var initialVariant = findExactVariant(variants, initialValues) || findPartialVariant(variants, initialValues) || variants[0];
  applyVariantSelection(initialVariant, variants);
}

function pdpAddToCart() {
  var variantId = document.getElementById('pdp-variant');
  if (!variantId) return;
  var vid = variantId.value;
  var activeVariant = getVariantById(vid);
  var btns = [document.getElementById('pdp-atc'), document.querySelector('.sticky-atc .btn-green')];
  if (!vid) {
    alert('Variant ID not found. Please contact support.');
    return;
  }
  if (!activeVariant || !activeVariant.available) {
    alert('This variant is sold out.');
    return;
  }
  btns.forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Adding...'; } });
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(vid, 10), quantity: _pdpQty })
  })
  .then(function (res) {
    if (res.ok) {
      btns.forEach(function (b) {
        if (b) {
          b.textContent = 'Added!';
        }
      });
      setTimeout(function () {
        if (activeVariant) updateActionButtons(activeVariant);
      }, 300);
      openCart();
    } else {
      return res.json().then(function (e) { throw new Error(e.description || 'Error'); });
    }
  })
  .catch(function (err) {
    if (activeVariant) updateActionButtons(activeVariant);
    else btns.forEach(function (b) { if (b) { b.disabled = false; b.textContent = 'Add to Cart'; } });
    alert('Error: ' + err.message);
  });
}

function pdpBuyNow() {
  var variantId = document.getElementById('pdp-variant');
  if (!variantId) return;
  var vid = variantId.value;
  var activeVariant = getVariantById(vid);
  var btn = document.getElementById('pdp-buy');
  if (!vid) {
    alert('Variant ID not found. Please contact support.');
    return;
  }
  if (!activeVariant || !activeVariant.available) {
    alert('This variant is sold out.');
    return;
  }
  if (btn) { btn.disabled = true; btn.textContent = 'Redirecting...'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(vid, 10), quantity: _pdpQty })
  })
  .then(function (res) {
    if (res.ok) window.location.href = '/checkout';
    else return res.json().then(function (e) { throw new Error(e.description || 'Error'); });
  })
  .catch(function (err) {
    if (btn && activeVariant) updateActionButtons(activeVariant);
    else if (btn) { btn.disabled = false; btn.textContent = 'Buy it now'; }
    alert('Error: ' + err.message);
  });
}

function openCart() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (drawer) drawer.classList.add('is-open');
  if (overlay) overlay.classList.add('is-open');
  if (typeof updateStickyAtcVisibility === 'function') updateStickyAtcVisibility();
  refreshCart();
}
function closeCart() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('is-open');
  if (typeof updateStickyAtcVisibility === 'function') updateStickyAtcVisibility();
}

function refreshCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var items = document.getElementById('cd-items');
      var foot = document.getElementById('cd-foot');
      if (!items || !foot) return;
      if (!cart.items || !cart.items.length) {
        items.innerHTML = '<p class="cd-empty">Your cart is empty.</p>';
        foot.style.display = 'none';
        setBadge(0);
        return;
      }
      foot.style.display = 'block';
      var html = '';
      cart.items.forEach(function (item) {
        var vt = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cd-variant">' + item.variant_title + '</div>' : '';
        var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
        html += '<div class="cd-item">' + img +
          '<div class="cd-info">' +
            '<div class="cd-title">' + item.product_title + '</div>' + vt +
            '<div class="cd-row">' +
              '<div class="cd-price">' + moneyFromCents(item.line_price) + '</div>' +
              '<div class="cd-qty">' +
                '<button onclick="cdQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">&#x2212;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button onclick="cdQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
              '</div>' +
            '</div>' +
          '</div></div>';
      });
      items.innerHTML = html;
      var total = document.getElementById('cd-total');
      if (total) total.textContent = moneyFromCents(cart.total_price);
      setBadge(cart.item_count);
    })
    .catch(function () {
      var items = document.getElementById('cd-items');
      if (items) items.innerHTML = '<p class="cd-empty">Could not load cart.</p>';
    });
}

function cdQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(refreshCart);
}

function setBadge(n) {
  var b = document.getElementById('cart-badge');
  if (!b) return;
  b.textContent = n > 0 ? n : '';
  n > 0 ? b.classList.add('has-items') : b.classList.remove('has-items');
}

document.addEventListener('click', function (e) {
  var go = e.target.closest ? e.target.closest('[data-go]') : null;
  if (!go) return;
  var target = go.getAttribute('data-go');
  if (!target) return;
  if (target === 'cart') {
    e.preventDefault();
    openCart();
    return;
  }
  if (target === 'shop') {
    e.preventDefault();
    window.location.href = '/';
    return;
  }
  if (target === 'product') {
    e.preventDefault();
    window.location.href = '/products/the-weekender';
    return;
  }
  if (target.charAt(0) !== '/') target = '/' + target;
  e.preventDefault();
  window.location.href = target;
});

function setStickyAtcVisible(visible) {
  var sticky = document.getElementById('sticky-atc');
  if (!sticky) return;
  sticky.classList.toggle('is-visible', visible);
  sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
  document.body.classList.toggle('has-mobile-sticky-atc', visible);
}

function updateStickyAtcVisibility() {
  var atc = document.getElementById('pdp-atc');
  var sticky = document.getElementById('sticky-atc');
  if (!atc || !sticky || window.innerWidth > 780) {
    setStickyAtcVisible(false);
    return;
  }

  var atcRect = atc.getBoundingClientRect();
  var footer = document.querySelector('footer');
  var footerIsNear = footer && footer.getBoundingClientRect().top < window.innerHeight + 12;
  var drawerOpen = document.getElementById('cart-drawer') && document.getElementById('cart-drawer').classList.contains('is-open');
  var zoomOpen = document.getElementById('pdp-zoom-overlay') && document.getElementById('pdp-zoom-overlay').classList.contains('is-open');
  setStickyAtcVisible(atcRect.bottom < 0 && !footerIsNear && !drawerOpen && !zoomOpen);
}

function initStickyAtc() {
  var ticking = false;
  var requestUpdate = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateStickyAtcVisibility();
      ticking = false;
    });
  };
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  requestUpdate();
}

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setBadge(c.item_count); }).catch(function () {});

  initPdpGallery();
  initPdpVariantUI();
  initStickyAtc();
});

/* ============================================================
   FLOATING REEL — appears 3 seconds after page load
   ============================================================ */
function closeFloatReel(){
  var r=document.getElementById('float-reel');
  if(!r)return;
  r.classList.remove('is-visible');
  setTimeout(function(){r.style.display='none';},600);
  try{sessionStorage.setItem('lh_reel_closed','1');}catch(e){}
}

document.addEventListener('DOMContentLoaded',function(){
  var r=document.getElementById('float-reel');
  if(!r)return;
  try{if(sessionStorage.getItem('lh_reel_closed')==='1'){r.style.display='none';return;}}catch(e){}
  setTimeout(function(){r.classList.add('is-visible');},3000);
});

/* ============================================================
   SCROLL REVEAL — Intersection Observer
   ============================================================ */
(function(){
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
        // Trigger number counters if in view
        var nums=entry.target.querySelectorAll?entry.target.querySelectorAll('[data-count]'):[];
        nums.forEach(animateCounter);
        // Trigger review bars
        var bars=entry.target.querySelectorAll?entry.target.querySelectorAll('.rv-bar-fill[data-width]'):[];
        bars.forEach(function(b){b.style.width=b.getAttribute('data-width')+'%';});
      }
    });
  },{threshold:0.12,rootMargin:'0px 0px -40px 0px'});

  function init(){
    document.querySelectorAll('.reveal-on-scroll').forEach(function(el){io.observe(el);});
    // Also observe individual numbers/bars not inside reveal elements
    document.querySelectorAll('[data-count]').forEach(function(el){io.observe(el);});
    document.querySelectorAll('.rv-bar-fill[data-width]').forEach(function(el){io.observe(el);});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}
})();

/* ============================================================
   ANIMATED COUNTER
   ============================================================ */
function animateCounter(el){
  if(el.dataset.counted)return;
  el.dataset.counted='1';
  var target=parseInt(el.getAttribute('data-count'),10);
  if(isNaN(target)||target===0){el.textContent='0';return;}
  var duration=1400,start=null;
  function step(ts){
    if(!start)start=ts;
    var progress=Math.min((ts-start)/duration,1);
    var ease=1-Math.pow(1-progress,3);
    el.textContent=Math.round(ease*target);
    if(progress<1)requestAnimationFrame(step);
    else el.textContent=target;
  }
  requestAnimationFrame(step);
}
